// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file core/v1/facility_events.proto (package core.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Facility } from "./facility_pb.js";
import { file_core_v1_facility } from "./facility_pb.js";
import type { ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file core/v1/facility_events.proto.
 */
export const file_core_v1_facility_events: GenFile = /*@__PURE__*/
  fileDesc("Ch1jb3JlL3YxL2ZhY2lsaXR5X2V2ZW50cy5wcm90bxIHY29yZS52MSKqAgoNRmFjaWxpdHlFdmVudBIwCgdjcmVhdGVkGAEgASgLMh0uY29yZS52MS5GYWNpbGl0eUNyZWF0ZWRFdmVudEgAEjAKB3VwZGF0ZWQYAiABKAsyHS5jb3JlLnYxLkZhY2lsaXR5VXBkYXRlZEV2ZW50SAASMAoHZGVsZXRlZBgDIAEoCzIdLmNvcmUudjEuRmFjaWxpdHlEZWxldGVkRXZlbnRIABI9Cg5ncm91cF9hc3NpZ25lZBgEIAEoCzIjLmNvcmUudjEuRmFjaWxpdHlHcm91cEFzc2lnbmVkRXZlbnRIABI7Cg1ncm91cF9yZW1vdmVkGAUgASgLMiIuY29yZS52MS5GYWNpbGl0eUdyb3VwUmVtb3ZlZEV2ZW50SABCBwoFZXZlbnQiOwoURmFjaWxpdHlDcmVhdGVkRXZlbnQSIwoIZmFjaWxpdHkYASABKAsyES5jb3JlLnYxLkZhY2lsaXR5InEKFEZhY2lsaXR5VXBkYXRlZEV2ZW50EiwKEXByZXZpb3VzX2ZhY2lsaXR5GAEgASgLMhEuY29yZS52MS5GYWNpbGl0eRIrChB1cGRhdGVkX2ZhY2lsaXR5GAIgASgLMhEuY29yZS52MS5GYWNpbGl0eSI7ChRGYWNpbGl0eURlbGV0ZWRFdmVudBIjCghmYWNpbGl0eRgBIAEoCzIRLmNvcmUudjEuRmFjaWxpdHkiZwoaRmFjaWxpdHlHcm91cEFzc2lnbmVkRXZlbnQSIwoIZmFjaWxpdHkYASABKAsyES5jb3JlLnYxLkZhY2lsaXR5EiQKEWZhY2lsaXR5X2dyb3VwX2lkGAIgASgLMgkudHlwZXMuSUQibwoZRmFjaWxpdHlHcm91cFJlbW92ZWRFdmVudBIjCghmYWNpbGl0eRgBIAEoCzIRLmNvcmUudjEuRmFjaWxpdHkSLQoacHJldmlvdXNfZmFjaWxpdHlfZ3JvdXBfaWQYAiABKAsyCS50eXBlcy5JREItWitwYWNrYWdlcy9iYWNrZW5kLW1vZHVsZS1jb3JlL2FwaS92MTtjb3JlX3YxYghlZGl0aW9uc3DoBw", [file_core_v1_facility, file_types]);

/**
 * @generated from message core.v1.FacilityEvent
 */
export type FacilityEvent = Message<"core.v1.FacilityEvent"> & {
  /**
   * @generated from oneof core.v1.FacilityEvent.event
   */
  event: {
    /**
     * @generated from field: core.v1.FacilityCreatedEvent created = 1;
     */
    value: FacilityCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: core.v1.FacilityUpdatedEvent updated = 2;
     */
    value: FacilityUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: core.v1.FacilityDeletedEvent deleted = 3;
     */
    value: FacilityDeletedEvent;
    case: "deleted";
  } | {
    /**
     * @generated from field: core.v1.FacilityGroupAssignedEvent group_assigned = 4;
     */
    value: FacilityGroupAssignedEvent;
    case: "groupAssigned";
  } | {
    /**
     * @generated from field: core.v1.FacilityGroupRemovedEvent group_removed = 5;
     */
    value: FacilityGroupRemovedEvent;
    case: "groupRemoved";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message core.v1.FacilityEvent.
 * Use `create(FacilityEventSchema)` to create a new message.
 */
export const FacilityEventSchema: GenMessage<FacilityEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_facility_events, 0);

/**
 * @generated from message core.v1.FacilityCreatedEvent
 */
export type FacilityCreatedEvent = Message<"core.v1.FacilityCreatedEvent"> & {
  /**
   * @generated from field: core.v1.Facility facility = 1;
   */
  facility?: Facility;
};

/**
 * Describes the message core.v1.FacilityCreatedEvent.
 * Use `create(FacilityCreatedEventSchema)` to create a new message.
 */
export const FacilityCreatedEventSchema: GenMessage<FacilityCreatedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_facility_events, 1);

/**
 * @generated from message core.v1.FacilityUpdatedEvent
 */
export type FacilityUpdatedEvent = Message<"core.v1.FacilityUpdatedEvent"> & {
  /**
   * @generated from field: core.v1.Facility previous_facility = 1;
   */
  previousFacility?: Facility;

  /**
   * @generated from field: core.v1.Facility updated_facility = 2;
   */
  updatedFacility?: Facility;
};

/**
 * Describes the message core.v1.FacilityUpdatedEvent.
 * Use `create(FacilityUpdatedEventSchema)` to create a new message.
 */
export const FacilityUpdatedEventSchema: GenMessage<FacilityUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_facility_events, 2);

/**
 * @generated from message core.v1.FacilityDeletedEvent
 */
export type FacilityDeletedEvent = Message<"core.v1.FacilityDeletedEvent"> & {
  /**
   * @generated from field: core.v1.Facility facility = 1;
   */
  facility?: Facility;
};

/**
 * Describes the message core.v1.FacilityDeletedEvent.
 * Use `create(FacilityDeletedEventSchema)` to create a new message.
 */
export const FacilityDeletedEventSchema: GenMessage<FacilityDeletedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_facility_events, 3);

/**
 * @generated from message core.v1.FacilityGroupAssignedEvent
 */
export type FacilityGroupAssignedEvent = Message<"core.v1.FacilityGroupAssignedEvent"> & {
  /**
   * @generated from field: core.v1.Facility facility = 1;
   */
  facility?: Facility;

  /**
   * @generated from field: types.ID facility_group_id = 2;
   */
  facilityGroupId?: ID;
};

/**
 * Describes the message core.v1.FacilityGroupAssignedEvent.
 * Use `create(FacilityGroupAssignedEventSchema)` to create a new message.
 */
export const FacilityGroupAssignedEventSchema: GenMessage<FacilityGroupAssignedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_facility_events, 4);

/**
 * @generated from message core.v1.FacilityGroupRemovedEvent
 */
export type FacilityGroupRemovedEvent = Message<"core.v1.FacilityGroupRemovedEvent"> & {
  /**
   * @generated from field: core.v1.Facility facility = 1;
   */
  facility?: Facility;

  /**
   * @generated from field: types.ID previous_facility_group_id = 2;
   */
  previousFacilityGroupId?: ID;
};

/**
 * Describes the message core.v1.FacilityGroupRemovedEvent.
 * Use `create(FacilityGroupRemovedEventSchema)` to create a new message.
 */
export const FacilityGroupRemovedEventSchema: GenMessage<FacilityGroupRemovedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_facility_events, 5);

